<template>
  <div class="container">
    <div class="row">
      <div>
        <div class="modal-content border-0 shadow pb-4">
          <div class="modal-header pb-0 border-0">
            <div class="col-12">
              <button
                type="button"
                class="btn btn-block d-flex ms-auto"
                style="left: 0; top: 0"
                @click="close"
              >
                <v-icon
                  icon="times"
                  width="20"
                  height="20"
                />
              </button>
            </div>
          </div>
          <div class="d-none d-md-flex mx-auto">
            <img
              :src="`${aws}/unicorn-feather.png`"
              class="mx-auto mb-3"
            >
          </div>
          <div
            v-if="amendmentComponentType && amendmentComponentType !== 'apply-amendment'"
            class="modal-body py-0"
          >
            <component
              :is="componentType"
              :contract="contract"
            />
          </div>
          <div class="modal-body">
            <section class="row">
              <div
                v-if="amendmentComponentType === 'apply-amendment'"
                class="col-12 col-md-9 mx-auto"
              >
                <div class="d-flex flex-column">
                  <h5 class="mb-3">
                    Date d'effet de l'avenant
                  </h5>
                  <div class="mb-3">
                    <label class="form-label fw-bold">Date d'effet</label>
                    <input
                      v-model="selectedEffectiveDate"
                      type="date"
                      class="form-control"
                      :class="{ 'is-invalid': amendmentFieldErrors.effectiveDate }"
                    >
                    <div
                      v-if="amendmentFieldErrors.effectiveDate"
                      class="invalid-feedback"
                    >
                      {{ amendmentFieldErrors.effectiveDate }}
                    </div>
                  </div>
                  <div
                    v-if="amendmentApplyError"
                    class="alert alert-danger py-2 mb-3"
                    role="alert"
                  >
                    {{ amendmentApplyError }}
                  </div>
                  <v-loader
                    id="confirm-apply-amendment-button"
                    title="Confirmer l'avenant"
                    :next="confirmApplyAmendment"
                    :force-loader="isApplyingAmendment"
                    icon="arrow-white-right"
                    class="mb-1"
                  />
                  <button
                    type="button"
                    class="btn btn-outline-secondary mt-2"
                    @click="close"
                  >
                    Annuler
                  </button>
                </div>
              </div>
              <div
                v-else-if="amendmentComponentType === 'date'"
                class="col-12 col-md-9 mx-auto"
              >
                <div class="d-flex flex-column">
                  <v-loader
                    :next="goToAmendmentDeclaration"
                    :title="amendmentDeclarationTitle"
                    :force-loader="isLoading"
                    icon="arrow-white-right"
                    class="mb-1"
                  />
                </div>
              </div>
              <div
                v-else-if="amendmentComponentType"
                class="col-12 col-md-9 mx-auto"
              >
                <div class="d-flex flex-column">
                  <v-loader
                    :next="goToAmendmentSummary"
                    :force-loader="isLoading"
                    class="mb-1 fs-6"
                  >
                    Valider
                    <span class="d-none d-lg-inline">
                      ma modification
                    </span>
                    <template v-if="shouldDisplayAmendmentPricing">
                      pour {{ amendmentPricing.displayAmount }} {{ amendmentPricing.displaySuffix }}
                    </template>
                  </v-loader>
                  <button
                    type="button"
                    class="btn btn-primary text-white"
                    @click="close"
                  >
                    Continuer à modifier
                  </button>
                </div>
              </div>
              <div
                v-else
                class="col-12 col-md-9 mx-auto"
              >
                <div class="d-flex flex-column">
                  <h5 class="mb-0">
                    Êtes-vous sûr de vouloir annuler vos modifications ?
                  </h5>
                  <p class="my-3">
                    Si vous annulez vos modifications, ces dernières seront perdues.
                  </p>
                  <button
                    type="button"
                    class="btn btn-primary mb-2 fs-5"
                    @click="close"
                  >
                    Poursuivre mes modification
                  </button>
                  <v-loader
                    id="confirm-revert-amendment-button"
                    title="Annuler mes modifications"
                    :next="deleteAmendment"
                    color="block"
                  />
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { ui } from '@/mixins';

import {
  Activities,
  Deductible,
  EffectiveDate,
  EmployeesBrackets,
  Formula,
  Liability,
  Local,
  LocalContent,
  LocalActivity,
  MainActivity,
  NegativeRevenue,
  ReportedRevenue,
} from '@/components/customisation';

import EquipmentFixeContent from '@/components/customisation/EquipmentFixeContent.vue';
import EquipmentMobilContent from '@/components/customisation/EquipmentMobileContent.vue';
import Territorialite from '@/components/customisation/Territorialite.vue';
import FinancialLoss from '@/components/customisation/extensions/FinancialLoss.vue';
import DynamicExtension from '@/components/customisation/extensions/DynamicExtension.vue';
import Equipment from '@/components/customisation/extensions/Equipment.vue';
import CustomisableCyber from '@/components/customisation/extensions/CustomisableCyber.vue';
import Effectif from '@/components/customisation/Effectif.vue';

export default {
  name: 'AmendmentModal',
  components: {
    'v-activity': Activities,
    'v-main-activity': MainActivity,
    'v-local-activity': LocalActivity,
    'v-liability': Liability,
    'v-equipment': Equipment,
    'v-deductible': Deductible,
    'v-date': EffectiveDate,
    'v-effectif-levels': EmployeesBrackets,
    'v-formula': Formula,
    'v-local': Local,
    'v-local-content': LocalContent,
    'v-negative-revenue': NegativeRevenue,
    'v-revenue': ReportedRevenue,
    'v-financial-loss': FinancialLoss,
    'v-customisable-extension': DynamicExtension,
    'v-equipment-fixe-content': EquipmentFixeContent,
    'v-equipment-mobil-content': EquipmentMobilContent,
    'v-territorialite': Territorialite,
    'v-customisable-cyber': CustomisableCyber,
    'v-effectif': Effectif,
  },
  mixins: [ui],
  data() {
    return {
      unsubscribe: () => {},
      isLoading: false,
      selectedEffectiveDate: '',
    };
  },
  computed: {
    subscriptionId() {
      return this.$route.params.id;
    },
    ...mapGetters({
      contract: 'contract/get',
      pendingAmendment: 'contract/pendingAmendment',
      amendmentPricing: 'contract/amendmentPricing',
      amendmentComponentType: 'ui/amendmentComponentType',
      isApplyingAmendment: 'contract/isApplyingAmendment',
      amendmentApplyError: 'contract/amendmentApplyError',
      amendmentFieldErrors: 'contract/amendmentFieldErrors',
    }),
    componentType() {
      return `v-${this.amendmentComponentType}`;
    },
    shouldDisplayAmendmentPricing() {
      return this.amendmentPricing.isReady && !this.amendmentPricing.isZero;
    },
    amendmentDeclarationTitle() {
      if (this.shouldDisplayAmendmentPricing) {
        return `Valider pour ${this.amendmentPricing.displayAmount} ${this.amendmentPricing.displaySuffix}`;
      }
      return 'Valider et signer';
    },
    resolvedAmendmentId() {
      const routeAmendmentId = this.$route.query.amendmentId;
      return routeAmendmentId
        || (this.contract.policyId ? this.contract.id : null)
        || (this.pendingAmendment && this.pendingAmendment.id)
        || this.subscriptionId
        || null;
    },
    aws: () => `${import.meta.env.VITE_AWS_STATIC}/common/png`,
  },
  watch: {
    amendmentComponentType: {
      handler(value) {
        if (value === 'apply-amendment') {
          this.selectedEffectiveDate = this.formatInputDate(new Date().toISOString());
        }
      },
      immediate: true,
    },
  },
  created() {
    this.$store.dispatch('contracts/setValue', { updateError: null });
    this.unsubscribe = this.$store.subscribeAction({
      before: (action) => {
        if (action.type === 'contract/updateSubscription') {
          this.isLoading = true;
        }
      },
      after: (action) => {
        if (action.type === 'contract/updateSubscription') {
          this.isLoading = false;
        }
      },
    });
  },
  beforeUnmount() {
    this.$store.dispatch('contracts/setValue', { updateError: null });
    this.unsubscribe();
  },
  methods: {
    close() {
      this.ui_showModal(false);
      this.$store.dispatch('contracts/setValue', { updateError: null });
    },
    goToAmendmentSummary() {
      this.ui_showModal(false);
      const amendmentId = this.resolvedAmendmentId || this.subscriptionId;
      return this.$router.push({
        path: `/client/contracts/${amendmentId}/summary`,
        query: {
          entity: 'subscription',
          amendmentId,
        },
      });
    },
    goToAmendmentDeclaration() {
      this.ui_showModal(false);
      const amendmentId = this.resolvedAmendmentId || this.subscriptionId;
      return this.$router.push({
        path: `/client/contracts/${amendmentId}/declarations`,
        query: {
          entity: 'subscription',
          amendmentId,
        },
      });
    },
    async deleteAmendment() {
      if (!this.resolvedAmendmentId) {
        this.ui_showToast({ show: true, message: 'Impossible d’annuler cet avenant pour le moment.' });
        return Promise.resolve();
      }

      const revertedSubscription = await this.$store.dispatch('contract/deleteAmendment', {
        subscriptionId: this.resolvedAmendmentId,
      });
      this.ui_showModal(false);
      if (revertedSubscription && revertedSubscription.policyId) {
        await this.$router.push(`/client/contracts/${revertedSubscription.policyId}`);
      }
      return Promise.resolve();
    },
    async confirmApplyAmendment() {
      try {
        const updatedSubscription = await this.$store.dispatch('contract/applyAmendment', {
          effectiveDate: this.selectedEffectiveDate,
          subscriptionId: this.resolvedAmendmentId,
        });
        this.ui_showModal(false);
        if (updatedSubscription && updatedSubscription.policyId) {
          this.$router.push(`/client/contracts/${updatedSubscription.policyId}`);
          return;
        }
        this.$router.push('/client/contracts/confirmation');
      } catch (error) {
        const status = error.response && error.response.status;
        if (status >= 500) {
          this.ui_showModal(false);
          this.ui_showToast({ show: true, message: 'Une erreur serveur est survenue. Veuillez réessayer.' });
        } else if (status === 422) {
          this.ui_showToast({ show: true, message: this.amendmentApplyError || 'Erreur de validation métier.' });
        }
        // 400 handled inline via amendmentFieldErrors — modal stays open
      }
    },
    formatInputDate(value) {
      if (!value) {
        return '';
      }

      return String(value).slice(0, 10);
    },
  },
};
</script>
